/**
 * @desc 新建月计划基础信息
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.PlanMonthInfoAddRequest,
): Promise<defs.StandardReturn<number>> {
  return defHttp.post({
    url: '/web/plan/month/addPlanInfo',
    data,
  });
}

export function mock(
  data: defs.PlanMonthInfoAddRequest,
): Promise<defs.StandardReturn<number>> {
  return defHttp.post({
    url: '/mock/web/plan/month/addPlanInfo',
    data,
  });
}
